<script setup lang="ts">
import NewHomeHero from '~/components/pages/home/NewComponents/HomeHero.vue'
import HomeExclusive from '~/components/pages/home/HomeExclusive.vue'
import GlobalLotteryResults from '~/components/pages/home/GlobalLotteryResults.vue'
import TicketScanner from '~/components/pages/home/TicketScanner.vue'
import { useNotificationStore } from '~/store/notification'
import { SHOW_SCAN_TICKET } from '~/config/featureFlags'

const notificationStore = useNotificationStore()

await useAsyncData('home:last-lotteries', async () => {
	try {
		return await notificationStore.fetchLastLotteries()
	} catch (error) {
		console.warn('[pages/index] fetchLastLotteries failed', error)
		return { success: false }
	}
})
</script>

<template>
	<main>
		<NewHomeHero />
		<GlobalLotteryResults v-if="notificationStore.getLasLotteries.length > 0" />
		<TicketScanner v-if="$hasFeature(SHOW_SCAN_TICKET)" />
		<HomeExclusive />
	</main>
</template>

<style lang="postcss">
html {
	scroll-behavior: smooth;
}
</style>
